import {fromJS} from 'immutable';

const defState = fromJS({
    blocks: [
        {
            type: 'text',
            image: 'https://via.placeholder.com/1200x800.jpg',
            title: '10 способов не ошибиться при установке окна',
            text: '<p>Удобное географическое расположение склада позволяет осуществлять поставки любым видом транспорта в любую точку Риги со значительной экономией на услугах перевозки.</p>',

        },
        {
            type: 'text',
            image: 'https://via.placeholder.com/1200x800.jpg',
            title: 'Доставка по всей Риге',
            text: '<p>Удобное географическое расположение склада позволяет осуществлять поставки любым видом транспорта в любую точку Риги со значительной экономией на услугах перевозки.</p>',
            mods: {
                reversed: true,
            }
        },
        {
            type: 'features',
            title: 'Почему выбирают нас?',
            text: '<p>Тысячи клиентов по всей Латвии предпочитают нас — мы принимаем все способы оплаты, рассрочку, выполняем заказы всрок и все наши продукты проверены европейскими специалистами.</p>',
            features: [
                {
                    icon: 'big-card',
                    title: 'Оплата',
                    text: 'Мы постарались сделать действительно удобно',
                },
                {
                    icon: 'big-calendar',
                    title: 'Сроки',
                    text: 'Получайте ваш заказ в тот же день',
                },
                {
                    icon: 'big-badge',
                    title: 'Сертификация',
                    text: 'Каждое изделие соответствует международным стандартам',
                }
            ]
        }
    ]
});

export default function reducer(state = defState, action) {
    switch (action.type) {
        case '':{
            return state;
        }
        default:
            return state;
    }
};